export default __webpack_public_path__ + "static/media/background.e910ef95.webp";